var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    height: 26,
    width: 26
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "passthrough"
    },
    fill: "currentColor",
    d: "M7.287 21.192a.257.257 0 0 1-.26.256 9.824 9.824 0 0 1-2.63-.384A5.82 5.82 0 0 1 0 15.441c.018-.416.064-.831.137-1.242l.013-.065a5.815 5.815 0 0 1 5.24-4.486 8.02 8.02 0 0 1 15.325.013c3.564.324 5.992 3.762 5.103 7.23 0 .022-.009.04-.013.056-.547 2.245-2.282 3.84-4.641 4.27-.602.094-1.208.151-1.816.172a.257.257 0 0 1-.27-.245L19 19.396a.257.257 0 0 1 .245-.269c.505-.016 1.01-.062 1.51-.137 1.478-.272 2.515-1.215 2.85-2.582l.015-.072a3.546 3.546 0 0 0-3.43-4.44c-.082 0-.173 0-.278.013l-1.018.08-.167-.913c-.497-2.717-2.821-4.762-5.583-4.806a5.755 5.755 0 0 0-5.755 4.725l-.189 1.028-1.037-.104a3.524 3.524 0 0 0-.353-.017 3.573 3.573 0 0 0-3.446 2.715 7.481 7.481 0 0 0-.1.824 3.557 3.557 0 0 0 2.713 3.435l.052.015a7.557 7.557 0 0 0 2.007.293c.14.004.25.118.25.257v1.75Z",
    "data-follow-fill": "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "passthrough"
    },
    fill: "currentColor",
    d: "m15.693 12.857-3.645 2.104a.755.755 0 0 1-1.132-.653V10.1a.755.755 0 0 1 1.132-.654l3.645 2.102a.755.755 0 0 1 0 1.31Z",
    "data-follow-fill": "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "passthrough"
    },
    fill: "currentColor",
    rx: 0.185,
    height: 3.963,
    width: 2.264,
    y: 17.545,
    x: 8.641,
    "data-follow-fill": "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "passthrough"
    },
    fill: "currentColor",
    rx: 0.185,
    height: 2.547,
    width: 2.264,
    y: 18.96,
    x: 11.848,
    "data-follow-fill": "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "passthrough"
    },
    fill: "currentColor",
    rx: 0.185,
    height: 5.095,
    width: 2.264,
    y: 16.413,
    x: 15.15,
    "data-follow-fill": "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCms);
export default __webpack_public_path__ + "static/media/cms.5f7638d8fa0fd78a138d832a11dd6aab.svg";
export { ForwardRef as ReactComponent };